export default initSpecialRefinement;

/**
 * javascript class for jQuery selector
 */
const JS_CLASS = {
    gradient: '.js-plp-specialRef-gradient',
    specialRef: '.js-plp-specialRef',
    specialRef_container: '.js-plp-specialRef-container',
    specialRef_chips: '.js-plp-specialRef-chips',
    leftWhiteShadow: '.js-white-shadow-left',
    rightWhiteShadow: '.js-white-shadow-right',
};

const CSS_CLASS = {
    specialRef_chips: 'js-plp-specialRef-chips',
};

function initSpecialRefinement() {
    const $specialRef = $(JS_CLASS.specialRef);
    let resizeTimeout;

    if ($specialRef.length > 0) {
        checkSizeContainer();
        $(window).on('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                $specialRef.off();
                checkSizeContainer();
            }, 300);
        });
    }
}

function checkSizeContainer() {
    const $specialRef_container = $(JS_CLASS.specialRef_container);
    const specialRef = document.querySelector(JS_CLASS.specialRef);
    const $specialRef = $(JS_CLASS.specialRef);
    const $specialRefGradient = $(JS_CLASS.gradient);
    const $leftWhiteShadow = $(JS_CLASS.leftWhiteShadow);
    const $rightWhiteShadow = $(JS_CLASS.rightWhiteShadow);

    specialRef.scrollLeft = 0;

    if ($specialRef_container.prop('scrollWidth') > $specialRef_container.width() + 1) {
        $specialRefGradient.removeClass('hide');
        $leftWhiteShadow.toggleClass('js-shadow-on');
        $rightWhiteShadow.toggleClass('js-shadow-on');
        $specialRefGradient.css({
            width: '',
            right: 0,
        });
        let actionStart = false;
        let startX, scrollLeft;
        const maxScrollLeft = specialRef.scrollWidth - specialRef.clientWidth;
        const gradientInitialWidth = $specialRefGradient.width();

        updateShadowVisibility(specialRef, maxScrollLeft, $leftWhiteShadow, $rightWhiteShadow);

        $specialRefGradient.css('width', Math.min(gradientInitialWidth, maxScrollLeft * 2));

        const activeButton = $('.js-plp-specialRef-chips[data-active="true"]');
        if (activeButton.length > 0) {
            const distanceFromLeft = activeButton[0].offsetLeft;
            const activeButtonWidth = activeButton[0].clientWidth / 2;
            const containerWidth = specialRef.clientWidth / 2;
            specialRef.scrollLeft = distanceFromLeft - containerWidth + activeButtonWidth;
            $specialRefGradient.css('right', -(distanceFromLeft - containerWidth + activeButtonWidth));
            updateShadowVisibility(specialRef, maxScrollLeft, $leftWhiteShadow, $rightWhiteShadow);
        }

        function startDragging(e) {
            e.preventDefault();
            e.stopPropagation();

            if (e.type === 'mousedown' && e.which !== 1) {
                //check only left button
                return;
            }

            actionStart = true;
            let moveX = e.type === 'touchstart' ? e.touches[0].pageX : e.pageX;
            startX = moveX - specialRef.offsetLeft;
            scrollLeft = specialRef.scrollLeft;
        }
        function stopDragging(e) {
            e.preventDefault();
            e.stopPropagation();

            if (!actionStart) {
                return;
            }
            let moveX =
                e.type === 'touchend' || e.type === 'touchcancel'
                    ? e.changedTouches[0].pageX
                    : e.pageX;

            const x = moveX - specialRef.offsetLeft;
            const scroll = x - startX;

            let [$chips, url] = findChips(e.target);

            if (Math.abs(scroll) < 12 && url) {
                changeLocation($chips, url);
            }
            actionStart = false;
            updateShadowVisibility(specialRef, maxScrollLeft, $leftWhiteShadow, $rightWhiteShadow);
        }
        function dragging(e) {
            e.preventDefault();
            e.stopPropagation();

            if (!actionStart) {
                return;
            }
            let moveX = e.type === 'touchmove' ? e.touches[0].pageX : e.pageX;
            const x = moveX - specialRef.offsetLeft;
            const scroll = x - startX;
            specialRef.scrollLeft = scrollLeft - scroll;

            let calculateScroll = (maxScrollLeft - specialRef.scrollLeft) * 2;
            $specialRefGradient.css(
                'width',
                calculateScroll < gradientInitialWidth ? calculateScroll : gradientInitialWidth
            );
            $specialRefGradient.css('right', -specialRef.scrollLeft);
            updateShadowVisibility(specialRef, maxScrollLeft, $leftWhiteShadow, $rightWhiteShadow);
        }

        $specialRef.on('mousemove', dragging);
        $specialRef.on('mousedown', startDragging);
        $specialRef.on('mouseup', stopDragging);
        $specialRef.on('mouseleave', stopDragging);
        $specialRef.on('touchmove', dragging);
        $specialRef.on('touchstart', startDragging);
        $specialRef.on('touchend', stopDragging);
        $specialRef.on('touchcancel', stopDragging);
    } else {
        specialRef.scrollLeft = 0;
        $specialRefGradient.addClass('hide');
        $leftWhiteShadow.addClass('hide');
        $rightWhiteShadow.addClass('hide');
        $specialRef.on('click', JS_CLASS.specialRef_chips, clickChips);
    }
}

function updateShadowVisibility (scrollablePlpChipsElement, maxScrollLeft, $leftWhiteShadow, $rightWhiteShadow) {
    const scrollLeft = scrollablePlpChipsElement.scrollLeft;
    const clientWidth = scrollablePlpChipsElement.clientWidth;

    if ($leftWhiteShadow && $leftWhiteShadow.length) {
        $leftWhiteShadow.css('left', scrollLeft);
        $leftWhiteShadow.toggleClass('hide', scrollLeft <= 0 || scrollLeft >= maxScrollLeft - 1);
    }

    if ($rightWhiteShadow && $rightWhiteShadow.length) {
        $rightWhiteShadow.css('left', (scrollLeft + clientWidth - $rightWhiteShadow.outerWidth()));
        $rightWhiteShadow.toggleClass('hide', scrollLeft >= maxScrollLeft - 1 || scrollLeft <= 0);
    }
}

function findChips (target) {
    let $target = $(target);
    let $chips = $target.hasClass(CSS_CLASS.specialRef_chips)
        ? $target
        : $target.closest(JS_CLASS.specialRef_chips);

    if ($chips.attr('href')) {
        window.location.replace($chips.attr('href'));
    } else if ($chips.length === 0 || !$chips.data('url')) {
        return [null, false];
    } else {
        return [$chips, $chips.data('url')];
    }
}

function clickChips(e) {
    let [$chips, url] = findChips(e.target);
    if (url) {
        changeLocation($chips, url);
    }
}

function changeLocation($chips, url) {
    var href = new URL(window.location.href);
    href.searchParams.set('start', 0);
    var searchParams = new URLSearchParams(href.search);

    if ($chips.data('active') || $chips.data('isCategory')) {
        window.location.href = url;
    } else {
        let oldPrefNumber = checkExistPrefProductType(searchParams);

        if (oldPrefNumber === 0) {
            window.location.href = url;
        } else {
            let prefValueSelect = $chips.data('id');
            searchParams.set('prefv' + oldPrefNumber, prefValueSelect);
            href.search = searchParams.toString();
            window.location.href = href.toString();
        }
    }
}

function checkExistPrefProductType(searchParams) {
    let prefNumber = 0;
    for (let [key, value] of searchParams.entries()) {
        if (value === 'productType') {
            prefNumber = parseInt(key.match(/\d+/)[0]);
            break;
        }
    }
    return prefNumber;
}
